import { ZipcodeState } from './zipcode.types';

import { RootState } from '~/redux/store';

export const selectZipcode = ({
  zipcode,
}: RootState): ZipcodeState['zipcode'] => zipcode.zipcode;
